'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _rules = require('./rules');

exports.default = tokenizer;


function tokenizer(input) {
  let output = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  if (input.length === 0) return output;

  try {
    var _getMatch = (0, _rules.getMatch)(input);

    const type = _getMatch.type,
          length = _getMatch.length,
          value = _getMatch.value,
          parse = _getMatch.parse;

    output.push({ type: type, value: value, parse: parse });
    return tokenizer(input.slice(length), output);
  } catch (e) {
    throw new Error('Found no matching rule: ' + input);
  }
}
module.exports = exports['default'];